import { render } from "./museumConfig.vue?vue&type=template&id=680765f8&scoped=true"
import script from "./museumConfig.vue?vue&type=script&lang=js"
export * from "./museumConfig.vue?vue&type=script&lang=js"

import "./museumConfig.vue?vue&type=style&index=0&id=680765f8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680765f8"]])

export default __exports__